import PaymentMethodOptions from './payment-method-options';

export default PaymentMethodOptions;
